import { render, staticRenderFns } from "./WalletActivity.vue?vue&type=template&id=129ff9d7&scoped=true"
import script from "./WalletActivity.vue?vue&type=script&lang=js"
export * from "./WalletActivity.vue?vue&type=script&lang=js"
import style0 from "./WalletActivity.vue?vue&type=style&index=0&id=129ff9d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129ff9d7",
  null
  
)

export default component.exports